import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_USER_IN_2N } from 'services/2n/get-user';
import { ALL_USERS } from '../get-all-users';
import { deleteUserAPI } from './api';

export function useDeleteUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (userId) => deleteUserAPI(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId]);
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'deleteUserSuccess',
            },
          });
        }, 100);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'deleteUserError',
            },
          });
        }, 100);
      },
    },
  );

  return {
    deleteUser: mutate,
    deleteUserAsync: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
